'use client';

import { NoResults } from '@/features/product-card';
import { PAGE_SIZE } from '@/app/(plp)/constants';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import PLPGridSkeleton from './plp-grid-skeleton';
import VirtualizedPLPGrid from './virtualized-plp-grid';
import usePLPData from '../_utils/use-plp-data';
import { usePLPFacetsContext } from '../facets-context/facets-context';
const PLPGrid = () => {
  const {
    searchParams
  } = usePLPFacetsContext();
  const {
    isLoading,
    products
  } = usePLPData({
    searchParams
  });
  const isLoadingPageData = isLoading && !PUBLIC_IS_BOT;
  if ((!products || !products?.length) && !isLoadingPageData) return <NoResults />;
  if (isLoadingPageData) return <PLPGridSkeleton count={PAGE_SIZE} />;
  return <VirtualizedPLPGrid data-sentry-element="VirtualizedPLPGrid" data-sentry-component="PLPGrid" data-sentry-source-file="plp-grid.tsx" />;
};
export default PLPGrid;